window.addEventListener('DOMContentLoaded', () => {
  let backToTop = document.querySelector('a.back-to-top');
  if (backToTop) {
    var darkRects = [...document.querySelectorAll('.dark-scheme')].map(el => el.getBoundingClientRect());
    var yellowRects = [...document.querySelectorAll('.yellow-scheme')].map(el => el.getBoundingClientRect());

    var toTopRect = backToTop.getBoundingClientRect();
    const toggleIsInSection = toTopRect => sectionRect => sectionRect.top <= toTopRect.top + toTopRect.height && sectionRect.top + sectionRect.height > toTopRect.top
  
    var toggleInDark = darkRects.some(toggleIsInSection(backToTop));
    var toggleInYellow = yellowRects.some(toggleIsInSection(backToTop));
    
    const setToggleStatus = (statusDark, statusYellow) => {
      if (statusDark) {
        backToTop.classList.add('toggle-dark');
        backToTop.classList.remove('toggle-light');
        backToTop.classList.remove('toggle-yellow');
      } else if (statusYellow) {
        backToTop.classList.add('toggle-yellow');
        backToTop.classList.remove('toggle-dark');
        backToTop.classList.remove('toggle-light');
      } else {
        backToTop.classList.add('toggle-light');
        backToTop.classList.remove('toggle-dark');
        backToTop.classList.remove('toggle-yellow');
      }
    }
    
    setToggleStatus(toggleInDark, toggleInYellow);
    
    window.addEventListener('scroll', function() {
    
      var darkRects = [...document.querySelectorAll('.dark-scheme')].map(el => el.getBoundingClientRect());
      var yellowRects = [...document.querySelectorAll('.yellow-scheme')].map(el => el.getBoundingClientRect());
    
      var toggleInDark = darkRects.some(toggleIsInSection(toTopRect));
      var toggleInYellow = yellowRects.some(toggleIsInSection(toTopRect));
    
      setToggleStatus(toggleInDark, toggleInYellow);
    
    });
  }
})